// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Modal } from 'components/atoms/Modal';
import dayjs from 'dayjs';
import TableFilterCalendar from '../TableFilterCalendar';
import { DATE_FORMAT } from 'util/ConstantValues';
import IconCalendarTablet from 'components/atoms/icons/IconCalendarTablet';
import styles from './CollectDateSelectModal.module.scss';
import { IconClose } from 'components/atoms/icons/IconClose';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

type CollectDateSelectModalProps = {
  state?: [string | undefined, (date: string | undefined) => void];
  onSubmitAndFinish: (selectedDate: string | undefined) => void;
  onSubmitAndContinue?: () => void;
  onClose?: () => void;
  title?: string;
  saveButtonLabel?: string;
  description?: string;
};

const CollectDateSelectModal: React.FC<CollectDateSelectModalProps> = ({
  state,
  onSubmitAndFinish,
  onSubmitAndContinue,
  onClose,
  title,
  saveButtonLabel,
  description,
}) => {
  const [selectedDate, setSelectedDate] = state ?? useState<string>();
  const { t } = useTranslation();

  const handleChangeDate = (val: string | undefined) => {
    let day = val ? dayjs(val) : undefined;

    if (!day) {
      setSelectedDate(undefined);
      return;
    }

    if (day.isBefore(dayjs(), 'day')) {
      day = day.endOf('day');
    } else if (day.isAfter(dayjs(), 'day')) {
      day = day.startOf('day');
    } else {
      day = dayjs();
    }

    setSelectedDate(day?.format(DATE_FORMAT.slaYMDHm));
  };

  return (
    <Modal centered isSmall contentClassName={styles.Wrapper}>
      <div className={styles.Head}>
        <div className={styles.Title}>
          {title ?? t('collect_registration.select_received_date')}
        </div>
        <div
          onClick={() => {
            setSelectedDate(undefined);
            onClose?.();
          }}
        >
          <IconClose />
        </div>
      </div>

      <div className={styles.Body}>
        {description && <div className={styles.Description}>{description}</div>}

        <TableFilterCalendar
          isSingle
          value={selectedDate}
          onChange={handleChangeDate}
          expanded={{
            icon: <IconCalendarTablet />,
          }}
          allowClear={false}
          calendarWrapperStyle={{
            zIndex: 30001,
            fontSize: 28,
          }}
          align="center"
          portalPositionPoint={(ref) => ref}
          fullWidth
          fontSizeType="large"
        />

        <div className={styles.ButtonGroup}>
          {onSubmitAndContinue && (
            <button
              className={styles.FinishButton}
              onClick={onSubmitAndContinue}
            >
              {t('collect_registration.button_submit_and_continue')}
            </button>
          )}

          <button
            className={styles.SubmitButton}
            onClick={() => onSubmitAndFinish(selectedDate)}
          >
            {!onSubmitAndContinue
              ? saveButtonLabel ?? t('collect_registration.button_to_recover')
              : t('collect_registration.button_submit_and_finish')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CollectDateSelectModal;
